import "./Footer.css";
import {Link} from "react-router-dom";

const Footer = () => {
    return (
        <footer className="site-footer">
            <div className="footer-container">

                <div className="footer-column">
                    <div className="footer-title">Контакты</div>
                    <div className="footer-text">Мы работаем по будням, с 10-00 до 19-00.</div>
                    <div className="footer-text">Все заявки пришедшие позже, обрабатываются на следующий рабочий день.
                    </div>
                    <div className="footer-text">Инернет платформа Factura F - это онлайн маркет. Все товары доступны
                        только онлайн.
                    </div>
                    <div className="footer-text">Информация, размещенная на сайте, не является публичной офертой</div>
                    <div className="footer-text">г.Москва, Ленинский проспект дом 30</div>
                        <div className="footer-text">Email: info@facturaflat15.ru</div>
                    <div className="footer-text">Телефон: +7 (985) 023 55 88</div>
                </div>

                <div className="footer-column">
                    <div className="footer-title">Информация</div>
                    <div className="footer-link"><Link to={"/payment"}>Оплата и доставка</Link></div>
                    <div className="footer-link"><Link to={"/about"}>О нас</Link></div>
                </div>

            </div>

            <div className="footer-bottom">
                © 2026 FACTURA FLAT. Все права защищены
            </div>
        </footer>
    );
};

export default Footer;
